import Config from "src/Constants/Config";
import "./index.sass";

const Page = () => {
  return (
    <div className="page-4">
      <div className="page-4-left">
        <img src={`${Config.BASE_URL}/images/4left.jpg`} alt="" />
      </div>
      <div className="page-4-right-real"></div>
      <div className="page-4-right">
        <img src={`${Config.BASE_URL}/images/4right.png`} alt="" />
      </div>
    </div>
  );
};

export default Page;
